module.exports = __webpack_public_path__ + "static/media/flooring.ae0eb4e7.svg";